import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'; // Import Container, Row, and Col from the correct source
import { Link } from 'react-router-dom';
import Academicleft from '../Academic/Academicleft'; // You should import 'Academicleft' if it's a local component

function OrdinancesELe() {
    return (
        <>
            <section className="project-detail">
                <Container>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h3>Ordinances & Regulations</h3>
                            </div>
                        </div>
                    </div>


                    <Row>
                        <Col md={4} className='c-left custom-padding-color mb-4'>
                    
                            <Academicleft activeIndex={14} />
                        </Col>
                        <Col md={8} className='c-right'>
                            <Row>

                    
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h3><p>B.Tech 2018 Batch Onwards</p></h3>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/btech/B.Tech-Ordinance-Regulations-2018.pdf" target="_blank" className="c-link">Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h3><p>B.Tech 2015 - 2017 Batches</p></h3>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/btech/B.Tech-Ordinance-Regulations.pdf" target="_blank" className="c-link">Click here</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4">
                                    <div className="services-box ">
                                        <h3><p>M.Tech </p></h3>
                                        <div className="services-content2">
                                            <Link to="https://files.iittp.ac.in/pdfs/ordinances/M.Tech%20Ordinances.pdf" target="_blank" className="c-link">Click here</Link>
                                        </div>
                                    </div>
                                </div>
                            </Row>{/*  row */}

                    <Row className="mt-4">
                        <div className="col-lg-4 col-md-4">
                            <div className="services-box ">
                                <h3><p>M.Sc </p></h3>
                                <div className="services-content2">
                                    <Link to="https://files.iittp.ac.in/pdfs/ordinances/M.Sc%20Ordinances.pdf" target="_blank" className="c-link">Click here</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="services-box ">
                                <h3><p>Dual Degree </p></h3>
                                <div className="services-content2">
                                    <Link to="https://files.iittp.ac.in/pdfs/msphd/ordinance/Dual-Degree%20O&R.pdf" target="_blank" className="c-link">Click here</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="services-box ">
                            <h4><p>Master of Public Policy (MPP) </p></h4>
                                <div className="services-content2">
                                    <Link to="https://files.iittp.ac.in/pdfs/ordinances/MPP_Ordinances%20and%20Regulations.pdf" target="_blank" className="c-link">Click here</Link>
                                </div>
                            </div>
                        </div>
                    </Row>{/*  row */}


                    <Row className=" mt-4">
                        <div className="col-lg-4 col-md-4">
                            <div className="services-box ">
                                <h3><p>M.S. (Research) </p></h3>
                                <p className='text-danger'> * Currently, we are following the IIT Madras ordinances </p>
                                <div className="services-content2">
                                    <Link to="https://www.iitm.ac.in/sites/default/files/Ordinances/ms-ord-2022.pdf" target="_blank" className="c-link">Click here</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                            <div className="services-box ">
                                <h3><p>Ph.D.</p></h3>
                                {/* <p className='text-danger'> * Currently, we are following the IIT Madras ordinances</p> */}
                                <div className="services-content2">
                                    <Link to="https://files.iittp.ac.in/pdfs/ordinances/phd/Ph_D_Ordinance_IITTP.pdf" target="_blank" className="c-link">Click here</Link>
                                </div>
                            </div>
                        </div>
                      
                    </Row>{/*  row */}
                    </Col>
                </Row>
                </Container>  {/*  container */}
            </section>
        </>
    )
}

export default OrdinancesELe;
